module.exports = __webpack_public_path__ + "img/10.8754bfe0.png";